import FormStruct from '@/components/Form/FormStruct/FormStruct';
import { FV } from '@/components/Form/Validation/FormValidators';
import i18n from '@/i18n';
import BFAssignment, { Assignment } from "@/modules/abstract-ui/forms/assignment/BFAssignment";
import BFInput from '@/modules/abstract-ui/forms/input/BFInput';
import ValidationPopover from '@/modules/abstract-ui/general/ValidationPopover/ValidationPopover';
import React from "react";
import { FormRenderProps, Field } from 'react-final-form';

type Props = {
  changeSigner: (signerId: string, reason: string) => void;
  signerIds: string[];
  onClose?: () => void;
};

type VacancyContractSignChangeFormState = {
  reason: string;
  signerId: Assignment[];
};

const VacancyContractSignChangeForm = (props: Props) => {
  const { changeSigner, signerIds, onClose } = props;

  const defaultReason = i18n.t(
    "apTemplate:Vacancy.Applicant.ContractDetails.ChangeSignerForm.DefaultReason",
    "Vertretung"
  );

  return (
    <FormStruct
      initialValues={{ reason: defaultReason, signerId: [] }}
      title={i18n.t(
        "apTemplate:Vacancy.Applicant.ContractDetails.ChangeSignerForm.Title",
        "Unterzeichner ändern"
      )}
      cancelText={i18n.t("Global.Buttons.cancel", "Abbrechen")}
      onAbort={() => {
        onClose?.();
      }}
      submitText={i18n.t(
        "apTemplate:Vacancy.Applicant.ContractDetails.ChangeSignerForm.Submit",
        "Anderen Unterzeichner eintragen"
      )}
      render={(props: FormRenderProps<VacancyContractSignChangeFormState>) => {
        return (
          <div>
            <div>
              <Field name="signerId" validate={FV.required()}>
                {({ input, meta }) => {
                  const errorMessage =
                    meta.error && meta.touched ? meta.error : undefined;

                  return (
                    <ValidationPopover level={"error"} message={errorMessage}>
                      <BFAssignment
                        error={meta.error && meta.touched}
                        asOverlay
                        label={i18n.t(
                          "apTemplate:Vacancy.Applicant.ContractDetails.ChangeSignerForm.Signer",
                          "Unterzeichner"
                        )}
                        maxAssignments={1}
                        assignmentType={"user"}
                        prefilteredUserIds={signerIds}
                        {...input}
                      />
                    </ValidationPopover>
                  );
                }}
              </Field>
            </div>
            <div className="margin-top-20">
              <Field name="reason" validate={FV.required()}>
                {({ input, meta }) => (
                  <BFInput
                    validation={{
                      message: meta.error,
                      level: "error",
                    }}
                    label={i18n.t(
                      "apTemplate:Vacancy.Applicant.ContractDetails.ChangeSignerForm.Reason",
                      "Grund für die Änderung"
                    )}
                    {...input}
                  />
                )}
              </Field>
            </div>
          </div>
        );
      }}
      onSubmit={(data: VacancyContractSignChangeFormState) => {
        const signerId = data.signerId?.[0].id;
        changeSigner(signerId, data.reason);
        onClose?.();
      }}
    />
  );
};

export default VacancyContractSignChangeForm;
